/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: diB0qQnqZI7L
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonNav from "../../ButtonNav"; // plasmic-import: n-yL9NcVDVDg/component
import ButtonDock from "../../ButtonDock"; // plasmic-import: mzA6SGO_FrzS/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicDock.module.css"; // plasmic-import: diB0qQnqZI7L/css

createPlasmicElementProxy;

export const PlasmicDock__VariantProps = new Array("variant");

export const PlasmicDock__ArgProps = new Array(
  "logoButton",
  "modulesWrapper",
  "logoutButton"
);

const $$ = {};

function PlasmicDock__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "variant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.variant
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"dock"}
      data-plasmic-override={overrides.dock}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.dock,
        {
          [sty.dockvariant__default]: hasVariant($state, "variant", "_default"),
          [sty.dockvariant_maybe]: hasVariant($state, "variant", "maybe")
        }
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__ymXwa)}>
        {renderPlasmicSlot({
          defaultContents: (
            <ButtonNav
              className={classNames("__wab_instance", sty.buttonNav__hoSae)}
              shape={"fullRounding"}
            />
          ),

          value: args.logoButton
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__kLtW)}>
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__uwvI9)}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock___8T1Si)}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__xIxDb)}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__frRmb)}
              />
            </React.Fragment>
          ),

          value: args.modulesWrapper
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___39E63)}>
        {renderPlasmicSlot({
          defaultContents: (
            <ButtonNav
              className={classNames("__wab_instance", sty.buttonNav__yZbVi)}
              shape={"fullRounding"}
            />
          ),

          value: args.logoutButton
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  dock: ["dock"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDock__ArgProps,
          internalVariantPropNames: PlasmicDock__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDock__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "dock") {
    func.displayName = "PlasmicDock";
  } else {
    func.displayName = `PlasmicDock.${nodeName}`;
  }
  return func;
}

export const PlasmicDock = Object.assign(
  // Top-level PlasmicDock renders the root element
  makeNodeComponent("dock"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicDock
    internalVariantProps: PlasmicDock__VariantProps,
    internalArgProps: PlasmicDock__ArgProps
  }
);

export default PlasmicDock;
/* prettier-ignore-end */
